import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevExpressModule } from '../devexpress.module';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { LocaleCurrencyPipe } from './pipes/locale-currency.pipe';
import { TruncatePipe } from './pipes/truncate';
import { TranslateModule } from '@ngx-translate/core';
import { InfoPanelComponent } from './components/info-panel/info-panel.component';
import { ProblemPreviewComponent } from './components/problem-preview/problem-preview.component';
import { TrustUrlPipe } from './pipes/trust-url.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { MessageComponent } from './components/message/message.component';
import { OrderSearchComponent } from './components/order-search/order-search.component';
import { MarkComponent } from './components/mark/mark.component';
import { CanDeactivateGuard } from './guards/can-deactivate-guard';
import { HighlightSearchPipe } from './pipes/highlight-search.pipe';
import { DialogEditTextComponent } from './dialogs/dialog-edit-text/dialog-edit-text.component';
import { DialogChangeOrderStatusComponent } from './dialogs/dialog-change-order-status/dialog-change-order-status.component';
import { DialogQRCodeLinkComponent } from './dialogs/dialog-qrcode-link/dialog-qrcode-link.component';
import { KeyWordsComponent } from './components/key-words/key-words.component';
import { SearchServiceFullComponent } from './components/search-service-full/search-service-full.component';
import { NotificationsComponent } from './components/toolbar/notifications/notifications.component';
import { NotificationsPageComponent } from './components/toolbar/notifications-page/notifications-page.component';
import { StarComponent } from './components/star/star.component';
import { OrderPreviewComponent } from './components/toolbar/order-preview/order-preview.component';

import { RefinementOfParametersComponent } from 'src/app/shared/components/order/refinement-of-parameters/refinement-of-parameters.component';
import { OrderBreadCrumpComponent } from 'src/app/shared/components/order/order-bread-crump/order-bread-crump.component';
import { OrderBaseAttrsComponent } from 'src/app/shared/components/order/order-base-attrs/order-base-attrs.component';
import { OrderDynamicAttrsComponent } from 'src/app/shared/components/order/order-dynamic-attrs/order-dynamic-attrs.component';
import { OrderTabActionsComponent } from 'src/app/shared/components/order/order-tab-actions/order-tab-actions.component';
import { OrderTabFilesComponent } from 'src/app/shared/components/order/order-tab-files/order-tab-files.component';
import { OrderTotalComponent } from 'src/app/shared/components/order/order-total/order-total.component';
import { AttrNumberComponent } from 'src/app/shared/components/order/attr-number/attr-number.component';
import { AttrStringComponent } from 'src/app/shared/components/order/attr-string/attr-string.component';

import { AttrUnknownComponent } from 'src/app/shared/components/order/attr-unknown/attr-unknown.component';
import { OrderDetailForGridComponent } from 'src/app/shared/components/order/order-detail-for-grid/order-detail-for-grid.component';
import { AttrDictionaryComponent } from 'src/app/shared/components/order/attr-dictionary/attr-dictionary.component';
import { AttrEntityComponent } from 'src/app/shared/components/order/attr-entity/attr-entity.component';
import { AttrLogicalComponent } from 'src/app/shared/components/order/attr-logical/attr-logical.component';
import { OrderTitleComponent } from 'src/app/shared/components/order/order-title/order-title.component';
import { OrderTabBasicComponent } from 'src/app/shared/components/order/order-tab-basic/order-tab-basic.component';
import { OrderStatusComponent } from 'src/app/shared/components/order/order-status/order-status.component';
import { AttrPhoneComponent } from 'src/app/shared/components/order/attr-phone/attr-phone.component';
import { AttrDateTimeComponent } from 'src/app/shared/components/order/attr-date-time/attr-date-time.component';

@NgModule({
  imports: [CommonModule, DevExpressModule, TranslateModule],
  declarations: [
    ToolbarComponent,
    LocaleCurrencyPipe,
    TruncatePipe,
    TrustUrlPipe,
    InfoPanelComponent,
    ProblemPreviewComponent,
    LoadingComponent,
    MessageComponent,
    OrderSearchComponent,
    MarkComponent,
    HighlightSearchPipe,
    DialogEditTextComponent,
    DialogChangeOrderStatusComponent,
    DialogQRCodeLinkComponent,
    KeyWordsComponent,
    SearchServiceFullComponent,
    NotificationsComponent,
    NotificationsPageComponent,
    StarComponent,
    OrderPreviewComponent,

    RefinementOfParametersComponent,
    OrderBreadCrumpComponent,
    OrderBaseAttrsComponent,
    OrderDynamicAttrsComponent,
    OrderTabActionsComponent,
    OrderTabFilesComponent,
    OrderTotalComponent,
    AttrNumberComponent,
    AttrStringComponent,
    AttrUnknownComponent,
    OrderDetailForGridComponent,
    AttrDictionaryComponent,
    AttrEntityComponent,
    AttrLogicalComponent,
    OrderTitleComponent,
    OrderTabBasicComponent,
    OrderStatusComponent,
    AttrPhoneComponent,
    AttrDateTimeComponent,
  ],
  providers: [CanDeactivateGuard],
  exports: [
    ToolbarComponent,
    LocaleCurrencyPipe,
    TruncatePipe,
    TrustUrlPipe,
    InfoPanelComponent,
    ProblemPreviewComponent,
    LoadingComponent,
    MessageComponent,
    OrderSearchComponent,
    MarkComponent,
    HighlightSearchPipe,
    DialogEditTextComponent,
    DialogChangeOrderStatusComponent,
    DialogQRCodeLinkComponent,
    KeyWordsComponent,
    SearchServiceFullComponent,

    RefinementOfParametersComponent,
    OrderBreadCrumpComponent,
    OrderBaseAttrsComponent,
    OrderDynamicAttrsComponent,
    OrderTabActionsComponent,
    OrderTabFilesComponent,
    OrderTotalComponent,
    AttrNumberComponent,
    AttrStringComponent,
    AttrUnknownComponent,
    OrderDetailForGridComponent,
    AttrDictionaryComponent,
    AttrEntityComponent,
    AttrLogicalComponent,
    OrderTitleComponent,
    OrderTabBasicComponent,
    OrderStatusComponent,
    AttrPhoneComponent,
    AttrDateTimeComponent,
  ],
})
export class SharedModule {}
